// extracted by mini-css-extract-plugin
export default {"IssueDetailContainer":"IssueDetail-module__IssueDetailContainer--w0tUF"};